<template >
    <v-flex >
        <v-toolbar flat class="mx-auto mb-4">
            <v-toolbar-title class="headline">{{msg}}</v-toolbar-title>
        </v-toolbar>
        <v-flex xs12>   
            <div class="mx-4 mb-4">Click button, check console.</div>       
            <v-btn round color="primary" dark  v-on:click.native="getUser()">Get User</v-btn>
            <v-btn round color="primary" dark  v-on:click.native="singleUser()">Single User</v-btn>
            <v-btn round color="primary" dark  v-on:click.native="listUsers()">List Users</v-btn> 
             <v-btn round color="primary" dark  v-on:click.native="updateUser()">Update User</v-btn>     
            <v-btn round color="primary" dark  v-on:click.native="deleteUser()">Delete User</v-btn>   
            <br>
            <v-btn round color="primary" dark  v-on:click.native="getActivity()">Get Activity </v-btn>  
            <v-btn round color="primary" dark  v-on:click.native="getActivityByUser()">Get Activity By User</v-btn> 
            <v-btn round color="primary" dark  v-on:click.native="listActivities()">List Activities</v-btn>   
            <v-btn round color="primary" dark  v-on:click.native="listActivitiesUser()">List Activities User</v-btn>              
            <v-btn round color="primary" dark  v-on:click.native="createActivity()">Create Activity</v-btn> 
            <v-btn round color="primary" dark  v-on:click.native="updateActivity()">Update Activity</v-btn>     
            <v-btn round color="primary" dark  v-on:click.native="deleteActivity()">Delete Activity</v-btn> 
        </v-flex>
    </v-flex>
</template>


<script>

import ListUsersQuery from './queries/ListUsersQuery';
import GetUserQuery from './queries/GetUserQuery';
import SingleUserQuery from './queries/GetUserQuery';
import ListActivitiesQuery from './queries/ListActivitiesQuery';
import ListActivitiesByUserQuery from './queries/ListActivitiesByUserQuery';
import GetActivityByUserQuery from './queries/GetActivityByUserQuery';
import GetActivityQuery from './queries/GetActivityQuery';

//CreateUser - see login page dialogs
import CreateActivityMutation from './mutations/CreateActivityMutation';
import UpdateActivityMutation from './mutations/UpdateActivityMutation';
import DeleteActivityMutation from './mutations/DeleteActivityMutation';
import UpdateUserMutation from './mutations/UpdateUserMutation';
import DeleteUserMutation from './mutations/DeleteUserMutation';


export default {
  data () {
    return {
      msg: 'Demo Queries',
      ListUsersQuery: ListUsersQuery,

      GetUserQuery: GetUserQuery,
      SingleUserQuery: SingleUserQuery,
      //CreateUserMutation See Login.vue
      DeleteUserMutation: DeleteUserMutation,
      UpdateUserMutation: UpdateUserMutation,
      ListActivitiesQuery: ListActivitiesQuery,
      ListActivitiesByUserQuery: ListActivitiesByUserQuery,
      CreateActivityMutation: CreateActivityMutation,
      UpdateActivityMutation: UpdateActivityMutation,
      DeleteActivityMutation: DeleteActivityMutation,
      GetActivityByUserQuery: GetActivityByUserQuery,
      GetActivityQuery: GetActivityQuery,
    }
  },
  
  methods: {
        listUsers: function(){
            console.log(ListUsersQuery );
            this.$apollo.query({ query: ListUsersQuery })
            .then(function logData(data) {
                 console.log('Payload: ');
                  console.log(data.data.listUsers);
            }).catch(console.error);
        },     
        getUser: function(){
            var that=this;
            console.log(GetUserQuery);
            this.$apollo.query({ 
                variables: {
                            id: 'ec7e7c8a-cd3e-4166-b0a6-3a9d03cc4460'                       
                    }, 
                query: GetUserQuery })
            .then(function logData(data) {
                 console.log('Payload: ');
                  console.log(data);
                  console.log(that);
                  console.log(localStorage);
            }).catch(console.error);
        },
        singleUser: function(){
            console.log(SingleUserQuery);
            this.$apollo.query({ 
                variables: {
                            id: '48bb77fd-fce3-473e-9212-7350a3365843'                       
                    }, 
                query: SingleUserQuery })
            .then(function logData(data) {
                 console.log('Payload: ');
                  console.log(data);
            }).catch(console.error);
        },        
        createUser: function(){ 
             // see Login.vue
        },
        updateUser: function(){ 
                  this.$apollo.mutate({
                    variables: {
                        input: {
                            //only the id must match
                            id: 'b9094df0-f171-4552-8ebe-381d3e7bee05',
                            username: 'lfb0.41219711408142646',
                            email: 'lenbrashear1@hotmail.com',
                            goals:  'test',
                            voicePursuit:  'test',  
                            gender: 'Male',
                            Age:    'test', 
                            voiceType: 'test',
                            voiceDescriptives: 'udpated-data',                         
                        }
                    },
                    mutation: UpdateUserMutation
                }).then(function(data) {
                    console.log(data);
                }).catch(
                    error => console.error(error)
                    
                );
        },
        deleteUser: function(){ 
                  this.$apollo.mutate({
                    variables: {
                        input: {
                            id: 'a816e5d1-f8f3-4dba-a22a-34acce8e14e7',                    
                        }
                    },
                    mutation: DeleteUserMutation
                }).then(function(data) {
                    console.log(data);
                }).catch(error => console.error(error));  
        },
        getActivity: function(){ 
            console.log(localStorage);
            this.$apollo.query({ 
                variables: {
                            id: 'ec7e7c8a-cd3e-4166-b0a6-3a9d03cc4460--1524494256683', 
                            date: '1524373200000',                   
                    },
                query: GetActivityQuery })
            .then(function logData(data) {
                console.log('Payload: ');
                console.log(data);

            }).catch(console.error); 
        },
        getActivityByUser: function(){ 
            this.$apollo.query({ 
                variables: {
                    actDate: localStorage.currentDate,
                    username: localStorage.subID,             
                },
                query: GetActivityByUserQuery})
            .then(function logData(data) {
                 console.log('Payload: ');
                  console.log(data);
            }).catch(console.error);
        },           
        listActivities: function(){ 
            this.$apollo.query({ query: ListActivitiesQuery })
            .then(function logData(data) {
                 console.log('Payload: ');
                  console.log(data);
            }).catch(console.error);
        },   
        listActivitiesUser: function(){ 
            this.$apollo.query({ 
                variables: {   
                    username: localStorage.subID,       
                },
                query: ListActivitiesByUserQuery })
            .then(function logData(data) {
                 console.log('Payload: ');
                  console.log(data);
            }).catch(console.error);
        },           
        createActivity: function(){ 
                this.$apollo.mutate({
                    variables: {
                        input: {
                            id: 'ec7e7c8a-cd3e-4166-b0a6-3a9d03cc4460'+'--'+( new Date().getTime() ),
                            username:  localStorage.subID,    
                            date: localStorage.currentDate,
                            activityType: 'Voice Lesson',
                            value: '25',
                            intensity: 'Light',
                            notes: 'This is faked data',                     
                        }
                    },
                    mutation: CreateActivityMutation
                }).then(function(data) {
                    console.log(data);
                }).catch(error => console.error(error));
        },
        updateActivity: function(){ 
                this.$apollo.mutate({
                    variables: {
                        input: {
                            id: 'ec7e7c8a-cd3e-4166-b0a6-3a9d03cc4460',
                            username: localStorage.subID,    
                            date: localStorage.currentDate,
                            activityType: 'Voice Lesson',
                            value: '35',
                            intensity: 'Light',
                            notes: 'This is faked data',                     
                        }
                    },
                    mutation: UpdateActivityMutation
                }).then(function(data) {
                    console.log(data);
                }).catch(error => console.error(error));
        },
        deleteActivity: function(){ 
                  this.$apollo.mutate({
                    variables: {
                        input: {
                            id: '48bb77fd-fce3-473e-9212-7350a3365841',                    
                        }
                    },
                    mutation: DeleteActivityMutation
                }).then(function(data) {
                    console.log(data);
                }).catch(error => console.error(error));         
        },
        
  }
  
}


</script>








// WEBPACK FOOTER //
// src/components/DemoQueries.vue